/**
 * 看板指标注释的前端唯一匹配键：由全部结构化维度规范化生成。
 * 批量拉取时的分组、单元格查找必须共用本实现，禁止各处另写拼接逻辑。
 */
export function buildAnnotationKey(
    pageKey: string,
    dims: Record<string, string>,
    dateKey: string,
    columnType: string,
    hubId: string,
    metricKey: string
): string {
    const sortedDims = Object.entries(dims).sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0));
    return JSON.stringify({ pageKey, dateKey, columnType, hubId, metricKey, dims: sortedDims });
}
